import { QueryKey } from "@tanstack/react-query";

export const stripeQueryKeys = {
  all: () => ["stripe"] as QueryKey,
  accountSession: () =>
    [...stripeQueryKeys.all(), "account-session"] as QueryKey,
};
